import { render, staticRenderFns } from "./ButtonsAction.vue?vue&type=template&id=72e1d4f6&scoped=true&"
import script from "./ButtonsAction.vue?vue&type=script&lang=js&"
export * from "./ButtonsAction.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsAction.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ButtonsAction.vue?vue&type=style&index=1&id=72e1d4f6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e1d4f6",
  null
  
)

export default component.exports